module.exports = __webpack_public_path__ + "static/img/new_logo_5.b51656c3.png";